// TODO: Remove redux and replace with zustand later
// @ts-ignore
import { createAction } from 'redux-actions'
import { Message, IMessage } from '@weblite/ts-action/message'
import { EventDeleteMessagesPayload } from '@weblite/ts-action/message'
import { dispatch } from '$setup/redux'
import { LastOpenedRoomsStateType } from './types'
export const SET_STORE = 'SET_STORE'
export const setStore = createAction(SET_STORE)

export const INSERT = 'INSERT'
export const insert = createAction(INSERT)

export const REPLACE = 'REPLACE'
export const replace = createAction(REPLACE)

export const REMOVE_ROOM = 'REMOVE_ROOM'
export const removeRoom = createAction(REMOVE_ROOM)

export const CLEAR = 'CLEAR'
export const clear = createAction(CLEAR)

export const DELETE_MESSAGE = 'DELETE_MESSAGE'
export const deleteMessage = createAction(DELETE_MESSAGE)

export const EDIT_MESSAGE = 'EDIT_MESSAGE'
export const editMessage = createAction(EDIT_MESSAGE)

// Dispatch functions
export const dispatchSetStore = (store: LastOpenedRoomsStateType) =>
  dispatch(setStore(store))

export const dispatchInsert = (roomId: string, messages: Message[]) =>
  dispatch(insert({ roomId, messages }))

export const dispatchReplace = (roomId: string, messages: Message[]) =>
  dispatch(replace({ roomId, messages }))

export const dispatchRemoveRoom = (roomId: string) =>
  dispatch(removeRoom(roomId))

export const dispatchClear = () => dispatch(clear())

export const dispatchDeleteMessage = (patch: EventDeleteMessagesPayload) =>
  dispatch(deleteMessage(patch))

export const dispatchEditMessage = (
  roomId: string,
  iid: number,
  patch: Pick<IMessage, 'body' | 'attachment' | 'pinned'>,
) => dispatch(editMessage({ roomId, iid, patch }))
